import { PlaceOrderErrorResponse } from '@enums/PlaceOrderErrorResponse';

type CheckoutPaymentErrorCode = 'invoiceBlocked' | 'orderLimit' | 'wrongStore' | 'noDeliverySlot' | 'default';
type CheckoutPaymentErrorTitleKey = `error.${CheckoutPaymentErrorCode}.title`;
type CheckoutPaymentErrorTextKey = `error.${CheckoutPaymentErrorCode}.text`;

type CheckoutPaymentErrorData = ErrorDataType & {
  show: true;
  title: CheckoutPaymentErrorTitleKey;
  text: CheckoutPaymentErrorTextKey;
};

const getCheckoutPaymentErrorMessage = (errorData: ErrorDataType): CheckoutPaymentErrorData => {
  let errorCode: CheckoutPaymentErrorCode;
  switch (errorData.errorCode) {
    case PlaceOrderErrorResponse.INVOICE_BLOCKED:
      errorCode = 'invoiceBlocked';
      break;
    case PlaceOrderErrorResponse.ORDER_LIMIT:
      errorCode = 'orderLimit';
      break;
    case PlaceOrderErrorResponse.WRONG_STORE:
      errorCode = 'wrongStore';
      break;
    case PlaceOrderErrorResponse.NO_DELIVERY_SLOT:
      errorCode = 'noDeliverySlot';
      break;
    default:
      errorCode = 'default';
      break;
  }
  return {
    ...errorData,
    title: `error.${errorCode}.title`,
    text: `error.${errorCode}.text`,
    show: true,
  };
};

export default getCheckoutPaymentErrorMessage;
